var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52px",
    height: "52px",
    viewBox: "0 0 52 52",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 28") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "GFL-Marketing",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GFL---Landing-Page",
    transform: "translate(-1461, -7396)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(-0, 7227)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-28",
    transform: "translate(1462, 170)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-8",
    stroke: "#C6A566",
    strokeWidth: 2,
    fill: "#1A1A1A",
    cx: 25,
    cy: 25,
    r: 25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5371578,15 L34.7588005,15 L27.7222947,23.0475962 L36,34 L29.5202086,34 L24.4413299,27.3591346 L18.636897,34 L15.410691,34 L22.9354628,25.390625 L15,15 L21.6440678,15 L26.2301173,21.0699519 L31.5371578,15 Z M30.2734375,32 L32,32 L20.8546196,17 L19,17 L30.2734375,32 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter-icon.11222d7776f2692720554e717127cb7e.svg";
export { ForwardRef as ReactComponent };